import React, {useEffect, useState} from 'react'
import axios from 'axios'
import {CSVLink} from 'react-csv'
import StatementList from './StatementList'
import {Page, Text, View, Document, StyleSheet, PDFDownloadLink} from '@react-pdf/renderer'
import {Dropdown} from 'react-bootstrap'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { useLocation } from 'react-router-dom'

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'

const getLocalData = () => {
  const data = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  return JSON.parse(data)
}

const Statements = () => {

    const [statementData, setStatementData] = useState([])
    const [loading, setLoading] = useState(false)
    const [serialStatementData, setSerialStatementData] = useState([])

    const [dateRange, setDateRange] = useState([null, null])
    const [startDate, endDate] = dateRange
    const [statementExportOption,setStatementExportOption] = useState("ALL_STMT");

    const apiToken = getLocalData().api_token

    const API_URL = process.env.REACT_APP_API_URL
    const GET_STATEMENTS_DATA = `${API_URL}/user/statements-export`
    const GET_SERIAL_STATEMENTS_DATA = `${API_URL}/user/statements-serial-export`

    const getStatementsData = async (startDate,endDate) => {
        setLoading(true)
        const config = {
          headers: {Authorization: `Bearer ${apiToken}`},
          params:{
            start_date : startDate,
            end_date : endDate
          }
        }
        await axios
          .get(GET_STATEMENTS_DATA, config)
          .then((response) => {
            setStatementData(response.data.data)
            setLoading(false)
          })
          .catch((error) => {
            console.error(error)
            setLoading(false)
          })
      }
    
      const getSerialStatementsData = async (startDate,endDate) => {
        setLoading(true)
        const config = {
          headers: {Authorization: `Bearer ${apiToken}`},
          params:{
            start_date : startDate,
            end_date : endDate
          }
        }
        await axios
          .get(GET_SERIAL_STATEMENTS_DATA, config)
          .then((response) => {
            setSerialStatementData(response.data.data);
            setLoading(false)
          })
          .catch((error) => {
            console.error(error)
            setLoading(false)
          })
      }


       useEffect(() => {
          getStatementsData(startDate,endDate)
          getSerialStatementsData(startDate,endDate)
        }, [])

        const Pdfstyles = StyleSheet.create({
    page: {
      flexDirection: 'column',
      padding: 20,
    },
    table: {
      display: 'table',
      width: 'auto',
      borderStyle: 'solid',
      borderWidth: 1,
      borderRightWidth: 0,
      borderBottomWidth: 0,
    },
    tableRow: {
      flexDirection: 'row',
    },
    tableCol: {
      width: '25%',
      borderStyle: 'solid',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
    },
    tableCell: {
      margin: 'auto',
      marginTop: 5,
      marginBottom: 5,
      fontSize: 10,
    },
    header: {
      fontSize: 18,
      marginBottom: 10,
      textAlign: 'center',
    },
  })

  const statementsCsvHeaders = [
    {label: 'Statement No', key: 'statement_no'},
    {label: 'User', key: 'user'},
    {label: 'Tracking Number', key: 'tracking'},
    // {label: 'Model', key: 'model'},
    // {label: 'UPC', key: 'upc'},
    {label: 'Description', key: 'description'},
    {label: 'Amount', key: 'amount'},
    {label: 'Payment', key: 'payment_status'},
    {label: 'Date', key: 'date'},
  ]

  const statementsCsvData = statementData.map((item) => ({
    statement_no: item.statement_no,
    user: item.user_name,
    tracking: item.tracking_no,
    // model: item.model,
    // upc: item.upc,
    description: item.description,
    amount: '$' + item.total.toFixed(2),
    payment_status: item.payment_status == 1 ? 'PAID' : 'PENDING',
    date: new Date(item.created_at).toLocaleDateString(),
  }))

  const StatementPdfDocument = ({data}) => (
    <Document>
      <Page size='A4' orientation='landscape' style={Pdfstyles.page}>
        <View style={Pdfstyles.table}>
          <View style={Pdfstyles.tableRow}>
            {statementsCsvHeaders.map((header, index) => (
              <View style={[Pdfstyles.tableCol, {backgroundColor: 'skyblue'}]} key={index}>
                <Text style={Pdfstyles.tableCell}>{header.label}</Text>
              </View>
            ))}
          </View>
          {data.map((item, index) => (
            <View style={Pdfstyles.tableRow} key={index}>
              {statementsCsvHeaders.map((header, headerIndex) => (
                <View style={Pdfstyles.tableCol} key={headerIndex}>
                  <Text style={Pdfstyles.tableCell}>{item[header.key]}</Text>
                </View>
              ))}
            </View>
          ))}
        </View>
      </Page>
    </Document>
  )

  const serialStatementsCsvHeaders = [
    {label: 'Statement No', key: 'statement_no'},
    {label: 'Tracking Number', key: 'tracking'},
    {label: 'Serial Number', key: 'serial'},
    {label: 'Model', key: 'model'},
    {label: 'UPC', key: 'upc'},
    {label: 'Description', key: 'description'},
    {label: 'Item Price', key: 'price'},
    {label: 'Payment', key: 'payment_status'},
    {label: 'Date', key: 'date'},
  ]

  const serialStatementsCsvData = serialStatementData.map((item) => ({
    statement_no: item.statement_no,
    tracking: item.tracking_no,
    serial: item.serial_no,
    model: item.model,
    upc: item.upc,
    description: item.name,
    price: '$' + ((item.commission_status == 1) 
    ? (item.price + item.commission).toFixed(2) 
    : item.price.toFixed(2)),
    payment_status: item.payment_status == 1 ? 'PAID' : 'PENDING',
    date: new Date(item.created_at).toLocaleDateString(),
  }))

  

  const SerialStatementPdfDocument = ({data}) => (
    <Document>
      <Page size='A4' orientation='landscape' style={Pdfstyles.page}>
        <View style={Pdfstyles.table}>
          <View style={Pdfstyles.tableRow}>
            {serialStatementsCsvHeaders.map((header, index) => (
              <View style={[Pdfstyles.tableCol, {backgroundColor: 'skyblue'}]} key={index}>
                <Text style={Pdfstyles.tableCell}>{header.label}</Text>
              </View>
            ))}
          </View>
          {data.map((item, index) => (
            <View style={Pdfstyles.tableRow} key={index}>
              {serialStatementsCsvHeaders.map((header, headerIndex) => (
                <View style={Pdfstyles.tableCol} key={headerIndex}>
                  <Text style={Pdfstyles.tableCell}>{item[header.key]}</Text>
                </View>
              ))}
            </View>
          ))}
        </View>
      </Page>
    </Document>
  )

  const handleExportStatementOption = (e)=>{
    const value = e.target.value;
    setStatementExportOption(value);
  }

  const currentDate = new Date()
  const formattedDate = currentDate.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  })

  // console.log('serialData',serialStatementData)

  return (
        <div>
            <div className='card card-body shadow top-rounded'>
              <div className='card-title d-flex justify-content-between align-items-center'>
                <div className='d-flex align-items-center'>
                  <h3 className='m-0 text-gray-800'>Statements</h3>
                </div>

                <div className='d-flex flex-column'>
                  <div className='d-flex align-items-center justify-content-end mb-3'>
                    {/* <button className='btn btn-sm btn-primary text-white ml-3'> */}

                    {/* </button> */}
                    <Dropdown>
                      <Dropdown.Toggle variant='success' id='dropdown-basic' className='btn btn-primary btn-sm'>
                        Export
                      </Dropdown.Toggle>

                      <Dropdown.Menu style={{width:'225px'}}>
                        <Dropdown.Item onClick={(e)=>{
                          e.preventDefault();
                          e.stopPropagation();
                        }}>
                          <DatePicker
                            selectsRange={true}
                            startDate={startDate}
                            endDate={endDate}
                            onChange={(update) => {
                              setDateRange(update)
                              const [start, end] = update;
                              getStatementsData(start,end);
                              getSerialStatementsData(start,end);
                            }}
                            isClearable={true}
                            className='form-control form-control-sm'
                            placeholderText='Select Date Range'
                          />
                        </Dropdown.Item>
                        <Dropdown.Item as="div" onClick={(e)=>{
                          e.preventDefault();
                          e.stopPropagation();
                        }}>
                          <div className="form-group">
                            <select value={statementExportOption} onChange={handleExportStatementOption} className="form-select form-control-sm">
                              <option value="ALL_STMT">Statements</option>
                              <option value="SERIAL_STMT">Serial Statements</option>
                            </select>
                          </div>
                        </Dropdown.Item>
                        
                        <Dropdown.Item as="div" >
                        {statementExportOption == "ALL_STMT" && (
                          <div className="d-flex justify-content-between align-items-center">
                          <button className='btn btn-sm btn-primary text-dark'>
                            <CSVLink
                              className='downloadbtn'
                              filename={`statement_${formattedDate}.csv`}
                              headers={statementsCsvHeaders}
                              data={statementsCsvData}
                              style={{color: '#fff'}}
                            >
                              {loading ? 'Loading' : 'Export CSV'}
                            </CSVLink>
                          </button>
                          <PDFDownloadLink
                            document={<StatementPdfDocument data={statementsCsvData} />}
                            fileName={`statement_${formattedDate}.pdf`}
                            className='btn btn-sm btn-danger ms-2'
                          >
                            {({blob, url, loading, error}) =>
                              loading ? 'Loading PDF' : 'Export PDF'
                            }
                          </PDFDownloadLink>
                          </div>
                        )}
                        {statementExportOption == "SERIAL_STMT" && (
                          <div className="d-flex justify-content-between align-items-center">
                          <button className='btn btn-sm btn-primary text-dark'>
                            <CSVLink
                              className='downloadbtn'
                              filename={`serial_statement_${formattedDate}.csv`}
                              headers={serialStatementsCsvHeaders}
                              data={serialStatementsCsvData}
                              style={{color: '#fff'}}
                            >
                              {loading ? 'Loading' : 'Export CSV'}
                            </CSVLink>
                          </button>
                          <PDFDownloadLink
                            document={<SerialStatementPdfDocument data={serialStatementsCsvData} />}
                            fileName={`serial_statement_${formattedDate}.pdf`}
                            className='btn btn-sm btn-danger ms-2'
                          >
                            {({blob, url, loading, error}) =>
                              loading ? 'Loading PDF' : 'Export PDF'
                            }
                          </PDFDownloadLink>
                          </div>
                        )}
                        </Dropdown.Item>

                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  
                </div>
              </div>
                <StatementList/>
                </div>
            </div>
  )
}

export default Statements